import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import { useTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';

const EntriesSummary = forwardRef((props, ref) => {
    const refContainerTotals = useRef();
    const { t } = useTranslation();

    const [showRoundingWarning, setShowRoundingWarning] = useState(false);
    const [totals, setTotals] = useState({
        totalWithoutDiscount: "0.00",
        totalWithDiscount: "0.00",
        totalWithoutVat: "0.00",
        totalWithVat: "0.00",
        totalPayment: "0.00",
        totalvat: "0.00"
    });

    useImperativeHandle(ref, () => ({

        calculate(nodes, saletaxes = null) {
            var _totalWithoutDiscount = 0;
            var _totalWithDiscount = 0;
            var _totalWithoutVat = 0;
            var _totalWithVat = 0;
            var totalDiscount = 0;
            var totalWithHoldTaxes = 0;
            var totalVirtualWithHoldTaxes = 0;
            var totalOtherTaxes = 0;
            var totalStumpOfDutyTaxes = 0;
            var totalFeesTaxes = 0;
            var totalDeductionsTaxes = 0;
            var totalVirtualDeductionsTaxes = 0;
            var totalvat = 0;
            nodes.entries.forEach(node => {
                if (node.product.model != undefined) {
                    var _quant = node.quantity;
                    if (_quant == "-") {
                        _quant = 1;
                    }
                    const _vatRaw = node.vat.model?.value ?? node.vat.label;
                    var _vat = _vatRaw === "-" ? 0 : _vatRaw;
                    const _vatIsAmount = node.vat.model?.isAmount === true;
                    _totalWithoutDiscount += parseFloat(node.unitPrice) * parseFloat(_quant);
                    var rowPrice = parseFloat(node.unitPrice) * parseFloat(_quant);
                    totalDiscount += rowPrice * node.discount / 100;
                    var priceWithoutVat = node.unitPrice * _quant;
                    var discount = node.discount
                    priceWithoutVat -= discount * priceWithoutVat / 100
                    _totalWithoutVat += parseFloat(parseFloat(priceWithoutVat).toFixed(2));
                    var priceWithVat = _vatIsAmount
                        ? parseFloat((priceWithoutVat + parseFloat(_vat)).toFixed(2))
                        : parseFloat(parseFloat(priceWithoutVat + priceWithoutVat * _vat / 100).toFixed(2));
                    priceWithVat = parseFloat(priceWithVat)
                    _totalWithVat += priceWithVat;
                    if (node.taxes && node.taxes.length > 0) {
                        node.taxes.forEach(e => {
                            if (saletaxes == null || saletaxes == undefined || saletaxes.length == 0) {
                                var am_val = e.myDataMoreTax.amountValue.replace("%", "");
                                var _calcAmount = am_val * priceWithoutVat / 100;
                                if (e.myDataMoreTax.type == "WITHHOLD_TAXES") {
                                    if (e.myDataMoreTax.uid != 24) {
                                        if (e.amount && !Number.isNaN(e.amount)) {
                                            totalVirtualWithHoldTaxes += parseFloat(e.amount)
                                        }
                                        else {
                                            totalVirtualWithHoldTaxes += _calcAmount;
                                        }
                                    }
                                    if (e.amount && !Number.isNaN(e.amount)) {
                                        totalWithHoldTaxes += parseFloat(e.amount)
                                    }
                                    else {
                                        totalWithHoldTaxes += _calcAmount;
                                    }
                                }
                                else if (e.myDataMoreTax.type == "OTHER_TAXES") {
                                    if (e.amount && !Number.isNaN(e.amount)) {
                                        totalOtherTaxes += parseFloat(e.amount)
                                    }
                                    else {
                                        totalOtherTaxes += _calcAmount;
                                    }
                                }
                                else if (e.myDataMoreTax.type == "FEES") {
                                    if (e.amount && !Number.isNaN(e.amount)) {
                                        totalFeesTaxes += parseFloat(e.amount)
                                    }
                                    else {
                                        totalFeesTaxes += _calcAmount;
                                    }
                                }
                                else if (e.myDataMoreTax.type == "DEDUCTION") {
                                    if (e.myDataMoreTax.subtracted) {
                                        if (e.amount && !Number.isNaN(e.amount)) {
                                            totalVirtualDeductionsTaxes += parseFloat(e.amount)
                                        }
                                        else {
                                            totalVirtualDeductionsTaxes += _calcAmount;
                                        }
                                    }
                                    if (e.amount && !Number.isNaN(e.amount)) {
                                        totalDeductionsTaxes += parseFloat(e.amount)
                                    }
                                    else {
                                        totalDeductionsTaxes += _calcAmount;
                                    }
                                }
                                else if (e.myDataMoreTax.type == "STUMP_DUTY") {
                                    if (e.amount && !Number.isNaN(e.amount)) {
                                        totalStumpOfDutyTaxes += parseFloat(e.amount)
                                    }
                                    else {
                                        totalStumpOfDutyTaxes += _calcAmount;
                                    }
                                }
                            }
                        })
                    }
                    totalvat += _vatIsAmount
                        ? parseFloat(parseFloat(_vat).toFixed(2))
                        : parseFloat(parseFloat(priceWithoutVat * _vat / 100).toFixed(2));
                }
            });

            _totalWithDiscount = _totalWithoutDiscount - totalDiscount;

            if (saletaxes && saletaxes.length > 0) {
                saletaxes.forEach(e => {
                    if (e.myDataMoreTax.type == "WITHHOLD_TAXES") {
                        if (e.myDataMoreTax.uid != 24) {
                            totalVirtualWithHoldTaxes += parseFloat(e.amount)
                        }
                        totalWithHoldTaxes += parseFloat(e.amount)
                    }
                    else if (e.myDataMoreTax.type == "DEDUCTION") {
                        if (e.myDataMoreTax.subtracted) {
                            totalVirtualDeductionsTaxes += parseFloat(e.amount)
                        }
                        totalDeductionsTaxes += parseFloat(e.amount)
                    }
                    else if (e.myDataMoreTax.type == "OTHER_TAXES") {
                        totalOtherTaxes += parseFloat(e.amount);
                    }
                    else if (e.myDataMoreTax.type == "FEES") {
                        totalFeesTaxes += parseFloat(e.amount);
                    }
                    else if (e.myDataMoreTax.type == "STUMP_DUTY") {
                        totalStumpOfDutyTaxes += parseFloat(e.amount);
                    }
                })
            }
            var totalTaxes = totalOtherTaxes + totalFeesTaxes + totalStumpOfDutyTaxes - totalWithHoldTaxes - totalDeductionsTaxes
            var totalVirtualTaxes = totalOtherTaxes + totalFeesTaxes + totalStumpOfDutyTaxes - totalVirtualWithHoldTaxes - totalVirtualDeductionsTaxes

            var _totals = {
                totalWithoutDiscount: parseFloat(_totalWithoutDiscount).toFixed(2),
                totalWithDiscount: parseFloat(_totalWithDiscount).toFixed(2),
                totalWithoutVat: parseFloat(_totalWithoutVat).toFixed(2),
                totalWithVat: parseFloat(_totalWithVat).toFixed(2),
                totalDiscount: parseFloat(totalDiscount).toFixed(2),
                moreTaxes: parseFloat(totalTaxes).toFixed(2),
                totalvat: parseFloat(totalvat).toFixed(2),
                totalPayment: parseFloat(parseFloat(_totalWithVat) + parseFloat(totalVirtualTaxes)).toFixed(2),
                totalOtherTaxes: parseFloat(totalOtherTaxes).toFixed(2),
                totalFeesTaxes: parseFloat(totalFeesTaxes).toFixed(2),
                totalStumpOfDutyTaxes: parseFloat(totalStumpOfDutyTaxes).toFixed(2),
                totalWithHoldTaxes: parseFloat(totalWithHoldTaxes + totalDeductionsTaxes).toFixed(2),
            }
            return _totals;
        },

        updateUI(_totals) {
            let container = ReactDOM.findDOMNode(refContainerTotals.current).getElementsByClassName('discount');
            let container2 = ReactDOM.findDOMNode(refContainerTotals.current).getElementsByClassName('withoutdiscount');
            let container3 = ReactDOM.findDOMNode(refContainerTotals.current).getElementsByClassName('moretaxes');

            if (parseFloat(_totals.totalDiscount) == 0) {
                container[0].style.display = "none";
                container2[0].style.display = "none";
            } else {
                container[0].style.display = "flex";
                container2[0].style.display = "flex";
            }
            if (parseFloat(_totals.moreTaxes) == 0) {
                container3[0].style.display = "none";
            } else {
                container3[0].style.display = "flex";
            }

            if (props.onUpdateComplete) {
                props.onUpdateComplete(_totals);
            }
        },

        calculateAndUpdateUI(nodes, saletaxes = null) {
            var _totals = this.calculate(nodes, saletaxes);
            this.updateUI(_totals)
            setTotals(_totals);
            const sumPriceWithVat = nodes.entries
                .filter(node => node.product?.model != null)
                .reduce((sum, node) => sum + parseFloat(node.priceWithVat || 0), 0);

            var p1 = parseFloat(sumPriceWithVat).toFixed(2);
            var p2 = _totals.totalWithVat

            var diff = p2 - p1;

            setShowRoundingWarning(diff !== 0);
        }

    }));

    const portalTarget = document.getElementById('rounding-warning-portal');
    const roundingWarning = showRoundingWarning && portalTarget
        ? ReactDOM.createPortal(
            <div className="alert alert-warning d-flex align-items-center gap-2 mb-2" role="alert">
                <i className="fa fa-exclamation-triangle"></i>
                <span>{t("errorBecauseOfMyDataWrongRounding")}</span>
            </div>,
            portalTarget
        )
        : null;

    return (
        <>
        {roundingWarning}
        <div ref={refContainerTotals} className="card totals">
            <div className="totals-header">
                <i className="fa fa-list-alt"></i>
                <span>{t("Totals")}</span>
            </div>
            <div className="totals-body">
                <div className="totals-row withoutdiscount" style={{ display: "none" }}>
                    <span className="totals-label">{t("TotalWithoutDiscount")}</span>
                    <span className="totals-value">{totals.totalWithoutDiscount}€</span>
                </div>
                <div className="totals-row discount" style={{ display: "none" }}>
                    <span className="totals-label">{t("TotalDiscount")}</span>
                    <span className="totals-value">−{totals.totalDiscount}€</span>
                </div>
                <div className="totals-row">
                    <span className="totals-label">{t("TotalWithoutVat")}</span>
                    <span className="totals-value">{totals.totalWithoutVat}€</span>
                </div>
                <div className="totals-row">
                    <span className="totals-label">{t("Vat")}</span>
                    <span className="totals-value">{totals.totalvat}€</span>
                </div>
                <div className="totals-row">
                    <span className="totals-label">{t("TotalWithVat")}</span>
                    <span className="totals-value">{totals.totalWithVat}€</span>
                </div>
                <div className="totals-row moretaxes" style={{ display: "none" }}>
                    <span className="totals-label">
                        {t("moreTaxes")}
                        <i className="fa fa-info-circle infoicon" style={{ marginLeft: 4, opacity: 0.6 }}></i>
                    </span>
                    <span className="totals-value">{totals.moreTaxes}€</span>
                </div>
            </div>
            <div className="totals-footer">
                <span className="totals-footer-label">{t("TotalPaymentAmount")}</span>
                <span className="totals-footer-value">{totals.totalPayment}<sup>€</sup></span>
            </div>
        </div>
        </>
    );
});

export default EntriesSummary;
